export default "__VITE_ASSET__VezRF51E__"